import { render, staticRenderFns } from "./CloseBig.vue?vue&type=template&id=182e0209"
import script from "./CloseBig.vue?vue&type=script&lang=js"
export * from "./CloseBig.vue?vue&type=script&lang=js"
import style0 from "./CloseBig.vue?vue&type=style&index=0&id=182e0209&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports